import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

const PREFIX = 'DialogAttempts';

const classes = {
  wrapper: `${PREFIX}-wrapper`,
  content: `${PREFIX}-content`,
  attempts: `${PREFIX}-attempts`,
  maxAttempts: `${PREFIX}-maxAttempts`,
};

interface DialogAttemptsProps {
  currentAttempt: number;
  maxAttempts: number;
}

const Root = styled(Box)(({ theme }) => ({
  [`&.${classes.wrapper}`]: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    borderRadius: 100,
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    gap: theme.spacing(2),
  },
  [`& .${classes.content}`]: {
    fontFamily: 'Source Sans Pro',
    fontSize: 16,
    fontWeight: 600,
  },
  [`& .${classes.attempts}`]: {
    boxSizing: 'border-box',
    marginLeft: 8,
    marginRight: 8,
    display: 'inline-flex',
    justifyContent: 'center',
    color: '#ffffff',
    height: 24,
    width: 24,
    borderRadius: 64,
    backgroundColor: 'rgba(1, 16, 18, 0.38)',
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '22px',
  },
  [`& .${classes.maxAttempts}`]: {
    backgroundColor: 'rgba(1, 16, 18, 0.9)',
  },
}));

function Attempt({
  number,
  isMaxAttempts,
}: {
  number: number;
  isMaxAttempts: boolean;
}) {
  return (
    <Box
      className={`${classes.attempts} ${isMaxAttempts ? classes.maxAttempts : classes.attempts}`}>
      {number}
    </Box>
  );
}

export function DialogAttempts({
  currentAttempt,
  maxAttempts,
}: DialogAttemptsProps) {
  return (
    <Root className={classes.wrapper}>
      <Typography className={classes.content}>
        Attempt <Attempt number={currentAttempt} isMaxAttempts={true} /> of{' '}
        <Attempt
          number={maxAttempts}
          isMaxAttempts={currentAttempt === maxAttempts}
        />
      </Typography>
    </Root>
  );
}
